import React from 'react';
import { motion } from 'framer-motion';
import { Slide, SlideHeader, itemVariants } from '../Slide';
export function SlideRecognition() {
  return <Slide data-id="element-210">
      <SlideHeader data-id="element-211">Recognition</SlideHeader>

      <div className="flex-1 flex flex-col justify-center max-w-5xl" data-id="element-212">
        <motion.div variants={itemVariants} className="mb-20" data-id="element-213">
          <h3 className="text-sm text-gray-400 uppercase tracking-widest mb-8" data-id="element-214">
            Featured In
          </h3>
          <div className="flex flex-wrap gap-12 md:gap-24 items-center" data-id="element-215">
            <span className="font-sans text-3xl md:text-5xl font-bold tracking-tighter" data-id="element-216">
              TechCrunch
            </span>
            <span className="font-sans text-3xl md:text-5xl font-black tracking-tight" data-id="element-217">
              TNW
            </span>
            <div className="flex items-center gap-4" data-id="element-218">
              <div className="w-10 h-10 md:w-14 md:h-14 rounded-full border-2 border-white flex items-center justify-center font-bold text-xl md:text-2xl" data-id="element-219">
                P
              </div>
              <span className="font-sans text-2xl md:text-3xl font-bold" data-id="element-220">
                Product Hunt #3
              </span>
            </div>
          </div>
        </motion.div>

        <motion.div variants={itemVariants} className="mb-20" data-id="element-221">
          <h3 className="text-sm text-gray-400 uppercase tracking-widest mb-8" data-id="element-222">
            Recognized By
          </h3>
          <div className="flex flex-wrap gap-12 md:gap-24 items-center" data-id="element-223">
            <span className="font-sans text-4xl md:text-6xl font-bold tracking-tighter" data-id="element-224">
              Gartner.
            </span>
            <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full border-2 border-white" data-id="element-225">
              <span className="font-sans text-3xl md:text-4xl font-bold" data-id="element-226">
                G2
              </span>
            </div>
          </div>
        </motion.div>

        <motion.div variants={itemVariants} data-id="element-227">
          <h3 className="text-sm text-gray-400 uppercase tracking-widest mb-8" data-id="element-228">
            Backed By
          </h3>
          <div className="flex items-center gap-6" data-id="element-229">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-white text-black flex items-center justify-center font-serif text-4xl md:text-5xl font-bold" data-id="element-230">
              Y
            </div>
            <span className="font-sans text-3xl md:text-5xl font-light" data-id="element-231">
              Combinator
            </span>
          </div>
        </motion.div>
      </div>
    </Slide>;
}